'use client';
import React from 'react';

const isValidUrl = (urlString: string) => {
  const urlPattern = new RegExp(
    '^(https?:\\/\\/)?' + // validate protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // validate domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // validate OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // validate port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // validate query string
      '(\\#[-a-z\\d_]*)?$',
    'i',
  ); // validate fragment locator
  return !!urlPattern.test(urlString);
};

type ImgixImageProps = {
  src: string;
  alt?: string;
  options?: any;
  width: number;
  height: number;
  classStack?: string;
  loadingType?: 'lazy' | 'eager';
  onClick?: (e: React.MouseEvent<HTMLImageElement>) => void;
};

const ImgixImage = ({
  src,
  alt = 'subrite image',
  options,
  // TODO: Think about how to handle width and height, as it's required  by next/image
  width,
  height,
  classStack,
  loadingType = 'lazy',
  onClick,
}: ImgixImageProps) => {
  let imgixUrl = src?.startsWith('blob:') ? src : ''; // Blob for local files
  if (options && isValidUrl(src)) {
    const url = new URL(src);
    url.search = new URLSearchParams({
      dpr: ((typeof window !== 'undefined' && window?.devicePixelRatio) || 1) + 1,
      auto: 'compress,enhance',
      ...options,
    }).toString();
    imgixUrl = url.toString();
  }

  /*
    using next/image to handle the image optimization required to install an additional package name 'sharp' for enchancing image loading.

    References:

    - https://stackoverflow.com/questions/76513624/next-image-incredibly-slow-on-first-load
    - https://nextjs.org/docs/messages/sharp-missing-in-production
    - https://github.com/vercel/next.js/issues/23637

    That's why we are using img tag instead of next/image.

  */

  return (
    <img
      src={imgixUrl}
      alt={alt}
      width={width}
      height={height}
      className={classStack}
      loading={loadingType}
      onClick={onClick}
    />
  );
};

export default ImgixImage;
